import { CarouselDirection } from '@hooks/useCarousel';
import { ReactComponent as ArrowDown } from '@img/icons/carousel-arrow-down.svg';
import { ReactComponent as ArrowUp } from '@img/icons/carousel-arrow-up.svg';
import { ReactComponent as ArrowLeft } from '@img/icons/nav-arrow-left.svg';
import { ReactComponent as ArrowRight } from '@img/icons/nav-arrow-right.svg';
import DotPagination from '@stories/Components/Misc/DotPagination/DotPagination';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Controls.styles';
const Controls = React.forwardRef((props, ref) => {
    const carousel = useCarouselContext();
    return (React.createElement(S.Container, { ref: ref, className: props.className, "data-hide-pagination-mobile": carousel.maxIndex > 24, "data-vertical": carousel.direction === CarouselDirection.Vertical },
        React.createElement(DotPagination, { ariaLabel: props.paginationTitle, count: carousel.maxIndex + 1, onChange: (index) => carousel.goToIndex(index), value: carousel.activeIndex }),
        React.createElement(S.ButtonWrapper, null,
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.Button, { "aria-label": "Previous", disabled: !props.wrap && carousel.activeIndex === 0, type: "button", onClick: (event) => {
                        event.preventDefault();
                        if (props.onPrevClick) {
                            props.onPrevClick();
                        }
                        else {
                            carousel.goToPrev(props.wrap);
                        }
                    } }, carousel.direction === CarouselDirection.Horizontal ? React.createElement(ArrowLeft, null) : React.createElement(ArrowUp, null))),
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.Button, { "aria-label": "Next", disabled: !props.wrap && carousel.activeIndex === carousel.maxIndex, type: "button", onClick: (event) => {
                        event.preventDefault();
                        if (props.onNextClick) {
                            props.onNextClick();
                        }
                        else {
                            carousel.goToNext(props.wrap);
                        }
                    } }, carousel.direction === CarouselDirection.Horizontal ? React.createElement(ArrowRight, null) : React.createElement(ArrowDown, null))))));
});
Controls.displayName = 'Controls';
export default Controls;
